var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({domProps:{"value":_vm.value},on:{"input":_vm.onInput,"change":_vm.onChange,"blur":_vm.onBlur}},'input',Object.assign({}, _vm.$props, _vm.inputAttributes),false))}
var staticRenderFns = []

export { render, staticRenderFns }